<div class="app-main__inner">
<div class="bl-page">

  <!-- Search bar -->
  <div class="bl-search-bar">
    <div class="bl-search-inner">
      <div class="bl-search-icon"><i class="pe-7s-search"></i></div>
      <input type="text" class="bl-search-input" [(ngModel)]="searchInput"
             placeholder="Enter book code or book name..."
             (keyup.enter)="search()" [disabled]="isSearching" />
      <button class="bl-search-btn" (click)="search()" [disabled]="isSearching || !searchInput.trim()">
        <span *ngIf="isSearching" class="spinner-border spinner-border-sm"></span>
        <span *ngIf="!isSearching">Search</span>
      </button>
    </div>
    <p class="bl-hint">Search by book code (e.g. B-001) or title. Fuzzy name matching is supported.</p>
  </div>

  <!-- Error -->
  <div class="alert alert-danger py-2 px-3 small mt-3" *ngIf="searchError">
    <i class="pe-7s-attention me-1"></i>{{ searchError }}
  </div>

  <!-- No results -->
  <div class="bl-empty" *ngIf="hasSearched && !isSearching && results.length === 0 && !searchError">
    <i class="pe-7s-search bl-empty-icon"></i>
    <p>No books found matching <strong>"{{ searchInput }}"</strong>.</p>
  </div>

  <!-- Results -->
  <div class="bl-results" *ngIf="results.length > 0">
    <p class="bl-results-meta text-muted small">{{ results.length }} book title(s) found</p>

    <div class="bl-book-card" *ngFor="let book of results">
      <div class="bl-book-icon"><i class="pe-7s-bookmarks"></i></div>
      <div class="bl-book-info">
        <div class="bl-book-name">{{ book.bookName }}</div>
        <div class="bl-book-meta">
          <span *ngIf="book.bookId" class="bl-code">{{ book.bookId }}</span>
          <span *ngIf="book.authorNames?.length">{{ book.authorNames.join(', ') }}</span>
        </div>
      </div>
      <div class="bl-book-stats">
        <span class="bl-stat bl-stat-center" title="At Center">
          <i class="pe-7s-home"></i> {{ book.available }}
        </span>
        <span class="bl-stat bl-stat-issued" title="Issued">
          <i class="pe-7s-user"></i> {{ book.issued }}
        </span>
        <span class="bl-stat bl-stat-total" title="Total copies">
          <i class="pe-7s-copy-file"></i> {{ book.totalCopies }}
        </span>
      </div>
      <button class="bl-view-btn" (click)="viewCopies(book)">
        <i class="pe-7s-map-marker me-1"></i> View Copies
      </button>
    </div>
  </div>

</div>
</div>

<!-- ── Copies Modal ────────────────────────────────────────────────────────── -->
<div class="bl-modal-backdrop" *ngIf="showCopiesModal" (click)="closeModal()"></div>
<div class="bl-modal" *ngIf="showCopiesModal" (click)="$event.stopPropagation()">

  <div class="bl-modal-header">
    <div class="bl-modal-title">
      <i class="pe-7s-map-marker me-2 text-primary"></i>Copy Locations
    </div>
    <button type="button" class="bl-modal-close" (click)="closeModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bl-modal-book-strip">
    <div class="bl-strip-icon"><i class="pe-7s-bookmarks"></i></div>
    <div class="bl-strip-info">
      <div class="bl-modal-book-name">{{ selectedBook?.bookName }}</div>
      <div class="bl-modal-book-meta">
        <span class="bl-code" *ngIf="selectedBook?.bookId">{{ selectedBook.bookId }}</span>
        <span *ngIf="selectedBook?.authorNames?.length" class="bl-author-names">
          {{ selectedBook.authorNames.join(', ') }}
        </span>
      </div>
    </div>
    <div class="bl-book-stats">
      <span class="bl-stat bl-stat-center" title="At Center"><i class="pe-7s-home"></i> {{ selectedBook?.available }}</span>
      <span class="bl-stat bl-stat-issued" title="Issued"><i class="pe-7s-user"></i> {{ selectedBook?.issued }}</span>
      <span class="bl-stat bl-stat-total" title="Total"><i class="pe-7s-copy-file"></i> {{ selectedBook?.totalCopies }}</span>
    </div>
  </div>

  <div class="bl-modal-body">

    <!-- Loading copies -->
    <div class="text-center py-4" *ngIf="isCopiesLoading">
      <div class="spinner-border text-primary spinner-border-sm"></div>
      <p class="text-muted small mt-2">Loading copy details…</p>
    </div>

    <!-- Error -->
    <div class="alert alert-danger py-2 px-3 small m-3" *ngIf="!isCopiesLoading && copiesError">
      <i class="pe-7s-attention me-1"></i>{{ copiesError }}
    </div>

    <!-- No copies -->
    <div class="bl-no-copies text-muted small"
         *ngIf="!isCopiesLoading && !copiesError && selectedBook?.copies?.length === 0">
      No inventory copies found for this book.
    </div>

    <!-- Copies table -->
    <table class="table table-sm bl-copies-table mb-0"
           *ngIf="!isCopiesLoading && !copiesError && selectedBook?.copies?.length > 0">
      <thead>
        <tr><th>Sr No.</th><th>Status</th><th>Location</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let copy of selectedBook?.copies" [class]="statusClass(copy.status)">
          <td class="bl-srno">{{ copy.bookSrNo }}</td>
          <td>
            <span class="bl-status-badge" [class]="'bl-badge-' + copy.status">
              {{ statusLabel(copy.status) }}
            </span>
          </td>
          <td class="bl-location">{{ copy.location }}</td>
        </tr>
      </tbody>
    </table>

  </div>

</div>
